module.exports = __webpack_public_path__ + "img/06.3b544f0b.png";